import { createContext, useContext, useState, useRef } from "react";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toastMessage, setToastMessage] = useState(null);
  const timeoutRef = useRef(null);
  const isShowingRef = useRef(false);
  const lastMessageRef = useRef(null);

  const showToast = (message, type = "success") => {
    // Prevent duplicate toasts (same message and type)
    if (isShowingRef.current || (lastMessageRef.current?.message === message && lastMessageRef.current?.type === type)) {
      return;
    }

    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    isShowingRef.current = true;
    lastMessageRef.current = { message, type };
    setToastMessage({ message, type });

    timeoutRef.current = setTimeout(() => {
      setToastMessage(null);
      isShowingRef.current = false;
      // Clear last message after a short delay to allow the same message to be shown again if needed
      setTimeout(() => {
        lastMessageRef.current = null;
      }, 100);
    }, 5000); // Auto-hide after 5 seconds
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toastMessage && (
        <div className={`custom-toast ${toastMessage.type}`}>
          {toastMessage.message}
        </div>
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
